import { z } from "zod";

export const WorkspaceChangeSchema = z.object({
    fromWorkspaceId: z.number(),
    toWorkspaceId: z.number(),
    changeStatus: z.enum(["Starting", "Complete"]),
});

export type WorkspaceChange = z.infer<typeof WorkspaceChangeSchema>;
